import { useTheme as emotionUseTheme } from '@emotion/react';
import type { Theme } from '@sds-system/types';

export const useTheme = () => {
  const theme = emotionUseTheme() as Theme;
  return theme;
};
